import { css } from 'lit';

import { buttons, spacing } from './index.js';

export default [
  buttons,
  spacing,
  css`
    :host {
      --synapse-table-group-background-color: var(--synapse-color-neutral-3);
      --table-header-bg-color: var(--synapse-color-neutral-1);
      --tabel-header-justify-content: start;
      --table-cel-text-align: left;
      --ui5_table_bottom_border: none;
      --sapList_HeaderBackground: var(--synapse-color-neutral-1);
      --sapList_BorderColor: var(--border-color-default);
    }

    .online {
      background-color: #00ff00;
    }
    .status {
      min-width: 10px;
      height: 10px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 7px;
    }
    div.container {
      margin-top: 8px;
    }

    table-pagination {
      display: flex;
    }

    synapse-data-grid::part(container) {
      overflow-y: hidden;
    }

    :host-context(devices-selector-table) synapse-data-grid::part(container) {
      overflow-y: visible;
      min-width: fit-content;
    }

    synapse-data-grid::part(action) {
      --goto-icon-size: 20px;
      color: var(--icon-color-default);
      width: 20px;
      height: 20px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: transparent;
      border: 1px solid transparent;
      margin-right: 15px;
      transition: transform 0.2s ease-in-out;
    }

    synapse-data-grid::part(action):hover {
      color: var(--interactive-color-brand-hover);
      transform: scale(1.2);
    }

    synapse-data-grid::part(action):active {
      color: var(--interactive-color-brand-pressed);
    }

    synapse-data-grid::part(row-actions) {
      gap: 10px;
      max-width: fit-content;
      margin-right: 10px;
    }

    synapse-data-grid::part(remote),
    synapse-data-grid::part(manage),
    synapse-data-grid::part(promote),
    synapse-data-grid::part(demote),
    synapse-data-grid::part(verify) {
      height: 32px;
    }

    synapse-data-grid::part(remove) {
      color: var(--icon-color-danger);
    }

    synapse-data-grid::part(remove):hover {
      color: var(--interactive-color-danger-hover);
    }

    synapse-data-grid::part(remove):active {
      color: var(--interactive-color-danger-pressed);
    }

    synapse-data-grid::part(star) {
      color: var(--icon-color-brand-default);
    }

    synapse-data-grid::part(disabled) {
      color: var(--icon-color-disabled);
    }

    synapse-data-grid::part(disabled):hover {
      color: var(--icon-color-disabled);
      transform: scale(1);
      cursor: not-allowed;
    }

    @media (max-width: 684px) {
      div.container {
        margin-top: unset;
        overflow: hidden;
      }
    }

    @media only screen and (hover: none) and (min-width: 684px) {
      synapse-data-grid::part(row-actions) {
        flex-shrink: 0;
        visibility: visible;
        background-color: var(--synapse-color-neutral-1);
      }

      synapse-data-grid::part(action-header) {
        padding-top: 10px;
        width: 320px;
      }

      :host-context(group-table) synapse-data-grid::part(action-header) {
        width: auto;
      }

      synapse-data-grid::part(action) {
        width: 18px;
        height: 18px;
      }

      synapse-data-grid::part(remote) {
        background-color: var(--synapse-color-neutral-1);
        flex-shrink: 0;
      }

      synapse-data-grid::part(manage) {
        background-color: var(--synapse-color-neutral-1);

        flex-shrink: 0;
      }
    }

    @media only screen and (hover: none) and (min-width: 521px) and (max-width: 683px) {
      synapse-data-grid::part(row-actions) {
        visibility: visible;
        background-color: transparent;
      }
    }

    @media only screen and (hover: none) and (max-width: 520px) {
      synapse-data-grid::part(row-actions) {
        visibility: visible;
        background-color: transparent;
        position: static;
        justify-content: flex-start;
      }
    }
  `,
];
